import { navigateTo } from '@/composables/nuxt';
import { useNuxtRoute } from '@/composables/utils/useRoute';
import { queryToString } from '@/utils/query';
import {
  buildExperienceListSortQuery,
  toExperienceListApiSort,
  toExperienceSortType,
  withExperienceListSortQuery,
  type ExperienceSortType,
} from '@/wabunka-src/common/features/Experience/utils/experienceListSort';

import type { LocationQueryRaw } from 'vue-router';

/**
 * 体験一覧の並び順。検索結果ページとエリア / テーマ / エリア×テーマページで共有する（spec.md C）。
 *
 * 並び順の正は URL のクエリで、切替は同じ面に留まる。`buildPath` は遷移先のパスを返す
 * （検索結果ページはパスをタグから組み立て直すため、固定値では渡せない）。
 */
export const useExperienceListSort = (buildPath: () => string) => {
  const route = useNuxtRoute();

  const selectedSortType = computed<ExperienceSortType>(() => toExperienceSortType(queryToString(route.query?.sort)));
  const experienceListApiSort = computed<string | undefined>(() => toExperienceListApiSort(selectedSortType.value));

  const handleSortChange = (sortType: ExperienceSortType) => {
    navigateTo({ path: buildPath(), query: buildExperienceListSortQuery(route.query, sortType) });
  };

  /** クエリを組み直して別の面へ渡す遷移（Show more・絞り込み）に、いまの並び順を引き継ぐ */
  const withCurrentSortQuery = (query: LocationQueryRaw): LocationQueryRaw => withExperienceListSortQuery(query, queryToString(route.query?.sort));

  return { selectedSortType, experienceListApiSort, handleSortChange, withCurrentSortQuery };
};
